import React, { useState } from "react";
import { Card, Input, Button, Form, Table, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./editFaq.css";

const EditFaq = () => {
  const [form] = Form.useForm();
  const [faqs, setFaqs] = useState([]);

  const handleAddFaq = (values) => {
    const newFaq = {
      key: Date.now(),
      title: values.title,
      answer: values.answer,
    };
    setFaqs([newFaq, ...faqs]);
    form.resetFields();
    message.success("FAQ added successfully!");
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Answer",
      dataIndex: "answer",
      key: "answer",
      ellipsis: true,
    },
  ];
  return (
    <div className="faq-page">
      <div className="faq-topbar">
        <h2 className="faq-title">FAQ Management</h2>
      </div>

      <Card className="faq-form-card">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleAddFaq}
          className="faq-form"
        >
          <Form.Item
            label="FAQ Title"
            name="title"
            rules={[{ required: true, message: "Please enter the FAQ title" }]}
          >
            <Input placeholder="Enter question or title" />
          </Form.Item>

          <Form.Item
            label="FAQ Answer"
            name="answer"
            rules={[{ required: true, message: "Please enter the answer" }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Enter answer or description"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              className="add-faq-button"
            >
              Add FAQ
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditFaq;
